import { extractI18nLabel } from "~/common/functions";
import type { Locale } from "~/i18n/resolveLocale";

// A GeoItem link carries two labels that mean different things: the GeoItem's own name (Miguel) and the
// link's heading (what the place is to that Record). Neither stands in for the other, and a Record name
// never stands in for either.

/** The GeoItem's own name, or null when it has none. */
export const geoItemPlaceName = (i18nLabel: unknown, locale: Locale): string | null =>
  extractI18nLabel(i18nLabel as Record<string, unknown> | null, locale);

/** How a GeoItem is named outside map labels: its place name, else its ID. */
export const geoItemDisplayName = (geoItemId: string, placeName: string | null): string => placeName || geoItemId;

/** A link's heading, shown only where one link is in context; null when empty, never substituted. */
export const geoItemLinkHeading = (i18nLabel: unknown, locale: Locale): string | null =>
  extractI18nLabel(i18nLabel as Record<string, unknown> | null, locale);
